import Vue from 'vue'
import Router from 'vue-router'
import login from './views/login/index.vue'
import home from './views/home/index.vue'
import config from './views/config/index.vue'
import control from './views/control/index.vue'
import person from './views/person/index.vue'
import monitor from './views/monitor/index.vue'
import record from './views/record/index.vue'
import security from './views/security/index.vue'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'login',
        redirect: "login"
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/home',
        name: 'home',
        component: home,
        redirect: '/config',
        children: [
            {
                path: '/monitor',
                name: 'monitor',
                component: monitor
            }, {
                path: '/config',
                name: 'config',
                component: config,
            }, {
                path: '/control',
                name: 'control',
                component: control,
            }, {
                path: '/person',
                name: 'person',
                component: person,
            }, {
                path: '/record',
                name: 'record',
                component: record,
            }, {
                path: '/security',
                name: 'security',
                component: security,
            }], 
    },
    ]
})
